import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from "@angular/forms";

export function maxTicketsQuantityValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const formGroup = control as FormGroup;

    const quantityControl = formGroup.get("quantity");
    const maxTicketsControl = formGroup.get("maxTickets");
    const minTicketsControl = formGroup.get("minTickets");

    if (!quantityControl || !maxTicketsControl) return null;

    const quantityValue = Number(quantityControl.value);
    const maxTicketsValue = Number(maxTicketsControl.value);
    const minTicketsValue = minTicketsControl
      ? Number(minTicketsControl.value)
      : undefined;

    if (!Number.isFinite(quantityValue) || !Number.isFinite(maxTicketsValue))
      return null;

    const errors: ValidationErrors = {};

    if (maxTicketsValue > quantityValue) {
      errors["maxTicketsExceededQuantity"] = true;
    }

    const halfQuantityControl = formGroup.get("halfPriceQuantity");
    if (halfQuantityControl && halfQuantityControl.enabled) {
      const halfQuantityValue = Number(halfQuantityControl.value);
      if (
        Number.isFinite(halfQuantityValue) &&
        maxTicketsValue > halfQuantityValue
      ) {
        errors["maxTicketsExceededQuantity"] = true;
      }
    }

    if (
      minTicketsControl &&
      Number.isFinite(minTicketsValue) &&
      maxTicketsValue < (minTicketsValue ?? 0)
    ) {
      errors["maxTicketsLessThanMinTickets"] = true;
    }

    return Object.keys(errors).length ? errors : null;
  };
}
